import DashboardLayout from '@/views/Layout/DashboardLayout.vue';

const ConceptPaymentTypesList = () => import(/* webpackChunkName: "roles" */ '@/views/ConceptPaymentTypes/List.vue');
const ConceptPaymentTypeEdit = () => import(/* webpackChunkName: "roles" */ '@/views/ConceptPaymentTypes/Edit.vue');
const ConceptPaymentTypeCreate = () => import(/* webpackChunkName: "roles" */ '@/views/ConceptPaymentTypes/Create.vue');

let conceptPaymentTypesPages = {
  path: '/concept-payment-types',
  redirect: '/concept-payment-types',
  component: DashboardLayout,
  name: 'ConceptPaymentTypes',
  meta: {
    title: 'Tipos de Concepto de Pago',
    auth: true,
  },
  children: [
    {
      path: '',
      name: 'ConceptPaymentTypesList',
      meta: {
        title: 'Listado',
        auth: ['concept_payment_types.index'],
      },
      component: ConceptPaymentTypesList,
    },
    {
      path: ':id/edit',
      name: 'ConceptPaymentTypeEdit',
      meta: {
        title: 'Editar',
        auth: ['concept_payment_types.update'],
      },
      component: ConceptPaymentTypeEdit,
    },
    {
      path: '/create',
      name: 'ConceptPaymentTypeCreate',
      meta: {
        title: 'Nuevo',
        auth: ['concept_payment_types.store'],
      },
      component: ConceptPaymentTypeCreate,
    },
  ],
};

export default conceptPaymentTypesPages;
